import { isObject } from '../lang';
import filter from './filter';
export default function pick(obj, props) {
    if (!isObject(obj) || !Array.isArray(props)) {
        return {};
    }
    const propsSet = new Set(props);
    return filter(obj, (value, key) => propsSet.has(key));
}
